import { clsx } from "clsx";
import { twMerge } from "tailwind-merge"

import CryptoJS from 'crypto-js';


// const KEY_STR = process.env.REACT_APP_RESPONSE_KEY || '';
// const IV_STR = process.env.REACT_APP_RESPONSE_IV || '';

// // 2. Parse them into CryptoJS format SECOND
// const ENCRYPTION_KEY = CryptoJS.enc.Hex.parse(KEY_STR);
// const ENCRYPTION_IV = CryptoJS.enc.Hex.parse(IV_STR);

export function decryptResponse  (encryptedPayload)  {
   if (!encryptedPayload || typeof encryptedPayload !== 'string') {
    console.error("Decryption Error: encryptedPayload is missing or not a string.");
    return null;
  }

  // 2. Check if .env variables are actually loaded
  const keyHex = process.env.REACT_APP_RESPONSE_KEY;
  const ivHex = process.env.REACT_APP_RESPONSE_IV;

  if (!keyHex || !ivHex) {
    console.error("Decryption Error: .env variables REACT_APP_RESPONSE_KEY or IV are missing.");
    return null;
  }

  try {
    const key = CryptoJS.enc.Hex.parse(keyHex);
    const iv = CryptoJS.enc.Hex.parse(ivHex);

    const bytes = CryptoJS.AES.decrypt(encryptedPayload, key, {
      iv: iv,
      mode: CryptoJS.mode.CBC,
      padding: CryptoJS.pad.Pkcs7,
    });

    const decryptedText = bytes.toString(CryptoJS.enc.Utf8);
    
    if (!decryptedText) {
      console.error("Decryption Error: Result was empty. Check if Keys/IV match Backend exactly.");
      return null;
    }

    return JSON.parse(decryptedText);
  } catch (e) {
    console.error("Decryption Error (Catch):", e.message);
    return null;
  }
};


export function cn(...inputs) {
  return twMerge(clsx(inputs));
}
